import React, { useState } from 'react';
import PlanList from '../../components/PlanList';
import PlanForm from '../../components/PlanForm';

const AdminPlansPage: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editPlan, setEditPlan] = useState<any>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const onEdit = (plan: any) => { setEditPlan(plan); setShowForm(true); };
  const onCreate = () => { setEditPlan(null); setShowForm(true); };
  const onSuccess = () => { setShowForm(false); setRefreshKey(k=>k+1); };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Subscription Plans</h1>
        {!showForm && <button className="bg-primary text-white px-4 py-2 rounded" onClick={onCreate}>Create Plan</button>}
      </div>
      {!showForm ? (
        <PlanList key={refreshKey} onEdit={onEdit} />
      ) : (
        <PlanForm initial={editPlan} onSuccess={onSuccess} onCancel={() => setShowForm(false)} />
      )}
    </div>
  );
};

export default AdminPlansPage;
